import * as React from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { Box, Button, FormHelperText, Grid, Stack } from '@mui/material'

import { getCodeSetLabelLookup } from '../../Functions/CodeSetFns'
import RelatedScreen from '../../Components/RelatedScreen'
import DetailIDSwitch from '../../Components/DetailIDSwitch'

import { useUserContext } from '../../Contexts/UserConfig'
import SampleCards from './SampleCards'
import { sampleRunDisabled } from './SampleRunFns'
import AddSampleToRun from './AddSampleToRun'
import { useGetSampleRun } from '../../APIs/Hooks/SampleRunHooks'
import DialogFinishRun from './DialogFinishRun'
import DialogDestroyRun from './DialogDestroyRun'
import PageSection from '../../Constants&Theme/PageSection'
import { stackGap } from '../../Constants&Theme/Spacing'
import { ReadOnlyTextField } from '../../garvan-react/Components/ReadOnlyTextField'

function SampleRunInfo() {
  const { loginConfig } = useUserContext()
  const { sample_run_id } = useParams()

  const [detailsActive, setDetailsActive] = useState(true)
  const [openFinish, setOpenFinish] = useState(false)
  const [openDestroy, setOpenDestroy] = useState(false)

  const { data: sampleRun, isLoading } = useGetSampleRun(sample_run_id)

  return (
    <Box
      sx={{
        maxWidth: 'md',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection
        title={'Sample Run Information'}
        loading={isLoading}
      >
        <Stack
          width={1}
          gap={stackGap.col}
        >
          <Stack
            direction={'row'}
            width={1}
            gap={stackGap.row}
          >
            <ReadOnlyTextField
              fullWidth
              label="Run ID"
              value={sampleRun?.runInfo.SampleRunID || ''}
            />
            <ReadOnlyTextField
              fullWidth
              label="Status"
              value={
                getCodeSetLabelLookup(
                  loginConfig,
                  ['SampleRunStatusID'],
                  sampleRun?.runInfo.Status,
                ) || ''
              }
            />
            <ReadOnlyTextField
              fullWidth
              label="Employee"
              value={sampleRun?.runInfo.EmployeeID || ''}
            />
          </Stack>
          <Stack
            direction={'row'}
            width={1}
            gap={stackGap.row}
          >
            <ReadOnlyTextField
              label="Run Type"
              fullWidth
              value={
                getCodeSetLabelLookup(
                  loginConfig,
                  ['SampleRunTypeID'],
                  sampleRun?.runInfo.RunType,
                ) || ''
              }
            />
            <ReadOnlyTextField
              label="Origin"
              value={
                getCodeSetLabelLookup(
                  loginConfig,
                  ['KV-Holdings'],
                  sampleRun?.runInfo.OriginHoldingID,
                ) || ''
              }
              fullWidth
            />
            <ReadOnlyTextField
              label="Destination"
              value={
                getCodeSetLabelLookup(
                  loginConfig,
                  ['KV-Facilities'],
                  sampleRun?.runInfo.DestinationFacilityID,
                ) || ''
              }
              fullWidth
            />
          </Stack>
        </Stack>
      </PageSection>
      {sampleRun?.runInfo?.ScreenCollectionID && (
        <RelatedScreen sampleRun={sampleRun} />
      )}
      <Stack
        mt={3}
        direction={'row'}
        width={1}
        gap={stackGap.row}
      >
        <Box sx={{ verticalAlign: 'top', flex: 1 }}>
          <Button
            tabIndex={-1}
            fullWidth
            variant="contained"
            color="success"
            disabled={sampleRunDisabled(sampleRun)}
            onClick={() => setOpenFinish(true)}
          >
            Finish Sample Run
          </Button>
          <FormHelperText>
            Marks status of Sample Run as Prepared
          </FormHelperText>
        </Box>
        <Box style={{ verticalAlign: 'top', flex: 1 }}>
          <Button
            tabIndex={-1}
            fullWidth
            variant="contained"
            color="error"
            disabled={sampleRunDisabled(sampleRun)}
            onClick={() => setOpenDestroy(true)}
          >
            Destroy Sample Run
          </Button>
          <FormHelperText>
            Marks the Sample Run and all linked Samples as Destroyed
          </FormHelperText>
        </Box>
      </Stack>
      <Box sx={{ display: 'flex', alignItems: 'flex-end', my: 2, width: 1 }}>
        <Box sx={{ flex: 1 }}>
          <DetailIDSwitch
            detailOn={detailsActive}
            setDetailOn={setDetailsActive}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <AddSampleToRun sampleRun={sampleRun} />
        </Box>
      </Box>
      <Grid
        container
        spacing={2}
      >
        <SampleCards
          samples={sampleRun?.samples ?? []}
          detailsActive={detailsActive}
        />
      </Grid>
      <DialogFinishRun
        open={openFinish}
        sampleRun={sampleRun}
        setOpen={setOpenFinish}
      />
      <DialogDestroyRun
        open={openDestroy}
        sampleRun={sampleRun}
        setOpen={setOpenDestroy}
      />
    </Box>
  )
}

export default SampleRunInfo
